import AuthService from "../../../../services/AuthService";
import GoogleCredentialsService from "../../../../services/GoogleCredentialsService";
import ServerSettingService from "../../../../services/server-setting-service";

const apiAuth = new AuthService();
const googleService = new GoogleCredentialsService();

export async function GoogleCredentialsUpload(prevState:any, formData:FormData):Promise<{message:string,success:boolean}>{
    // check formdata have a json file
    const file = formData.get("file") as File;
    if (file.type !== "application/json") {
        return { message: "Please upload a valid JSON file.",success:false };
    }
    
    try{
        const result = await googleService.googleCredentialsUpload(file);
        if(result.status === 200)
            return {
        message: "File uploaded successfully.",
        success:true
        }
    }
    catch(error){
        console.log(error);        
    }
    return { message: "Error uploading file.",success:false }

}

export async function signin(): Promise<{ message: string; success: boolean,url:string }> {
  try {
    const result = await googleService.signin();
    if (result.status === 200)
      return {
        message: "Signin successfully.",
        success: true,
        url:result.data.url
      };
  } catch (error) {
    console.log(error);
  }
  return { message: "Error signin.", success: false,url:"" };
}
// create action updateServerSetting
 
export type State = {message:string,success:boolean,defaultValues:{emailFromAddress:string,emailFromName:string}};

const serverSettingService = new ServerSettingService();
export async function updateServerSetting(prevState:any, formData:FormData):Promise<State>{
  const data = {
      emailFromAddress:formData.get("emailFromAddress") as string,
      emailFromName:formData.get("emailFromName") as string
  }
    try{
        const result = await serverSettingService.updateServerSetting(data);
        if(result.status === 200)
            return {
        message: "Server setting updated successfully.",
        success:true,
        defaultValues:data
        }
    }
    catch(error){
        console.log(error);        
    }
    return { message: "Error updating server setting.",success:false,defaultValues:data }

}
